import { useEffect, useState } from 'react';
import { fetchData } from './Helpers';
import { freeWImg, privateImg, professionalImg, amersImg, apacImg, emeaImg, japanImg } from '../../images/ImageResolver';

function Dropdown({ countriesData }){
  return(
    <ef-layout className="geography-layout">
      <table>
        <thead>
          <tr>
            <th>REGION</th>
            <th>COUNTRY</th>
          </tr>
        </thead>
        <tbody>
          {countriesData.map((item, idx) => (
            <tr key={idx}>
              <td>{item["region"]}</td>
              <td>{item["country"]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </ef-layout>
  );
}

function Countries({ countriesData}) {
  const [ddIndex, setDdIndex] = useState(0);
  return (
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="Countries" value="tab1" active ></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
          <ef-panel spacing>
            <img src={amersImg} alt="AMERICAS" />
            <span>AMERICAS</span>
            {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
            {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
        {ddIndex === 1 && <Dropdown countriesData={countriesData.filter(item => item["package"] === "Americas")} />}
        <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
          <ef-panel spacing>
            <img src={apacImg} alt="ASIA" />
            <span>APAC</span>
            {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
            {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
        {ddIndex === 2 && <Dropdown countriesData={countriesData.filter(item => item["package"] === "Asia/Pacific (ex Japan)")} />}
        <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 3 ? 0 : 3)}>
          <ef-panel spacing>
            <img src={japanImg} alt="JAPAN" />
            <span>JAPAN</span>
            {ddIndex !== 3 && <ef-icon icon="down"></ef-icon>}
            {ddIndex === 3 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
        {ddIndex === 3 && <Dropdown countriesData={countriesData.filter(item => item["package"] === "Japan")} />}
        <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 4 ? 0 : 4)}>
          <ef-panel spacing>
            <img src={emeaImg} alt="EMEA" />
            <span>EMEA</span>
            {ddIndex !== 4 && <ef-icon icon="down"></ef-icon>}
            {ddIndex === 4 && <ef-icon icon="up"></ef-icon>}
          </ef-panel>
        </ef-layout>
        {ddIndex === 4 && <Dropdown countriesData={countriesData.filter(item => item["package"] === "EMEA")} />}
      </ef-layout>
    </div>
  )
}

export default function WealthPackages() {
  const [loading, setLoading] = useState(false);
  const [countriesData, setCountriesData] = useState([]);

  useEffect(() => {
    fetchData("Ownership_Countries").then((res) => {
      setCountriesData(res);
      setLoading(false);
    });
  }, []);

  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeWImg} alt="Public"/>Redistribution - Free to Air</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Redistribution - Password Protected</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Financial Professional - Internal</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      <Countries countriesData={countriesData} />
    </div>
  );
}